import { useEffect, useState } from 'react';


const getTimeFromSeconds = (sec) => {
    const hours = (sec ? Math.floor(sec / 3600) : 0).toString();
    const minutes = (sec ? Math.floor((sec % 3600) / 60 ) : 2).toString();
    const seconds = (sec ? Math.floor(sec % 60) : 59).toString();

    return {hours, minutes, seconds};
}

export const CountdownTimer = ({ sec = 0, onOver = () => {} }) => {
    const [over, setOver] = useState(false);
    const [time, setTime] = useState(sec);
    const [times, setTimes] = useState(getTimeFromSeconds(sec) ?? {});

    const tick = (time) => {
        if (over) return;
        if ( time === 0) {
            setOver(true);
            onOver();
        } else {
            setTime(time - 1);
            setTimeout(() => tick(time - 1), 1000);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => tick(time), 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        setTimes(getTimeFromSeconds(time) ?? {});
    }, [time])

    return (
        ((times.hours !== '0') ? (times.hours.padStart(2, '0') + ":") : '') +
        times.minutes.padStart(2, '0') + ":" + times.seconds.padStart(2, '0')
    );
};